<div class="py-big px-plus">
  <common-ui-components-services-or-stores-selected
    [header]="header()"
    [services]="sections()"
  ></common-ui-components-services-or-stores-selected>
</div>
